import { CompanyState } from './company.state';
import { CoreState } from '@app/store/core/states';
import { CampaignState } from './campaign.state';
import { CompanySettingState } from './company-setting.state';
import { SearchBoxState } from './search-box.state';
import { LandingPageState } from './landing-page.state';


export interface CompanyFeatureState {
    company: CompanyState,
    campaign: CampaignState,
    companySetting: CompanySettingState,
    searchBox: SearchBoxState,
    landingPage: LandingPageState
}

export interface State extends CoreState {
    company: CompanyFeatureState
}
